import { createFileRoute, redirect } from '@tanstack/react-router';
import { requireAuth } from '../require-auth';
import { menuSearchSchema } from '../menu-search';

/**
 * The menu scoped to a single category (`/eats/menu/:categoryId`). Categories
 * are browsed on the categories page and products are narrowed by category on
 * the products page, so a legacy category link lands on the products page
 * with that category preselected — the selection stays shareable and
 * back-button-friendly navigation rather than local state. `search` (the
 * search box) and the other filters ride along untouched.
 */
export const Route = createFileRoute('/eats/menu_/$categoryId')({
  // Auth guard — see `require-auth.ts`.
  beforeLoad: (ctx) => {
    requireAuth();
    const { categoryId } = ctx.params;
    const { search, status, categoryStatus, allBranches } = ctx.search;
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/eats/menu/products',
      search: {
        ...(search ? { search } : {}),
        ...(status ? { status } : {}),
        ...(categoryStatus ? { categoryStatus } : {}),
        ...(allBranches !== undefined ? { allBranches } : {}),
        categoryId,
      },
      replace: true,
    });
  },
  validateSearch: menuSearchSchema,
});
